import { useEffect, useState } from 'react';
import { api, eur, monthsToLabel } from '../../lib/api';
import { TableScroll } from './TableScroll';

export function SensitivitySection({ scenarioKey = 'optimistic_moderate', revealPrivate = false }) {
  const [cases, setCases] = useState([]);
  const [busy, setBusy] = useState(true);
  const [activeKey, setActiveKey] = useState(scenarioKey);
  const [scenarioList, setScenarioList] = useState([]);

  useEffect(() => {
    let cancelled = false;
    api
      .get('/acquisition/config')
      .then(({ data }) => {
        if (cancelled) return;
        const list = Object.entries(data.scenarios || {}).map(([key, sc]) => ({ key, label: sc.label || key, color: sc.color }));
        setScenarioList(list);
        if (list.length && !list.some((s) => s.key === activeKey)) setActiveKey(list[0].key);
      })
      .catch(() => { if (!cancelled) setScenarioList([]); });
    return () => { cancelled = true; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    let cancelled = false;
    setBusy(true);
    api
      .get(`/acquisition/sensitivity/${activeKey}`)
      .then(({ data }) => { if (!cancelled) setCases(data.cases || []); })
      .catch(() => { if (!cancelled) setCases([]); })
      .finally(() => { if (!cancelled) setBusy(false); });
    return () => { cancelled = true; };
  }, [activeKey]);

  return (
    <section id="sensibilidade" className="acq-section">
      <div className="acq-container">
        <header>
          <span className="kicker">Sensibilidade</span>
          <h2>O que acontece se algo correr diferente do plano.</h2>
          <p className="section-lead">
            Cinco cenários de stress aplicados sobre o cenário selecionado. Não escondemos cenários negativos.
          </p>
        </header>
        <div className="body">
          <div className="scenario-tabs" style={{ marginBottom: '1rem' }}>
            {scenarioList.map((sc) => (
              <button
                key={sc.key}
                className="scenario-tab"
                aria-pressed={activeKey === sc.key}
                onClick={() => setActiveKey(sc.key)}
                data-testid={`sens-${sc.key}`}
              >
                Sobre {sc.label}
              </button>
            ))}
          </div>
          <TableScroll>
          <table className="data-table" data-testid="sensitivity-table">
            <thead>
              <tr>
                <th>Cenário</th>
                <th>Detalhe</th>
                <th className="num">EBITDA ano 1</th>
                <th className="num">Caixa acumulada 3 anos</th>
                {revealPrivate && <th className="num">Payback</th>}
              </tr>
            </thead>
            <tbody>
              {busy ? (
                <tr><td colSpan={revealPrivate ? 5 : 4} style={{ color: 'var(--muted)' }}>A calcular...</td></tr>
              ) : (
                cases.map((c) => (
                  <tr key={c.id} className={c.id === 'base' ? 'total' : ''}>
                    <td>{c.label}</td>
                    <td style={{ color: 'var(--muted)', fontSize: '.82rem' }}>{c.detail}</td>
                    <td className="num">{eur(c.ebitda_year1, 0)}</td>
                    <td className="num">{eur(c.cash_3y, 0)}</td>
                    {revealPrivate && <td className="num">{monthsToLabel(c.payback_months)}</td>}
                  </tr>
                ))
              )}
            </tbody>
          </table>
          </TableScroll>
        </div>
      </div>
    </section>
  );
}
